import { login, USERS, label, userColor } from '../lib/auth.js';
import { logoMark } from '../components/logo.js';
import { go } from '../router.js';

// Pick-a-user sign in (no passwords: a private app for the two of them).
export function renderLogin(el) {
  el.innerHTML = `
    <div class="min-h-screen bg-pagebg flex flex-col items-center justify-center px-6">
      <div class="w-full max-w-sm text-center">
        <div class="flex items-center justify-center gap-3 mb-2">
          ${logoMark({ size: 54 })}
          <span class="font-bold tracking-tight text-[44px] text-ink" style="letter-spacing:-0.03em">GR<span style="color:#EC7726">I</span>T</span>
        </div>
        <div class="text-[15px] text-inksoft mb-12">Train. Track. Transform.</div>

        <div class="grit-section mb-4">Who's training?</div>
        <div class="space-y-3">
          ${USERS.map((u) => `
          <button data-user="${u}" class="grit-btn !min-h-[56px] !text-[19px]" style="background:${userColor(u).deep}">
            ${label(u)}
          </button>`).join('')}
        </div>

        <p class="text-[13px] text-inksoft mt-8">Private to the two of you on this device.</p>
      </div>
    </div>`;

  el.querySelectorAll('[data-user]').forEach((btn) => {
    btn.onclick = () => {
      login(btn.getAttribute('data-user'));
      go('home');
    };
  });
}
